import React from 'react';
import { StarIcon } from 'lucide-react';
type StarsProps = {
  size?: number;
  className?: string;
};
export function Stars({
  size = 16,
  className = ''
}: StarsProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} role="img" aria-label="5 de 5 estrellas" data-id="element-174" data-mp="3kq4zv4m3vo1d">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} style={{
      width: size,
      height: size
    }} className="fill-amber-400 text-amber-400" data-id="element-175" data-mp="3pqj74kfvutyc" />)}
    </div>;
}